import { post } from "./Fetching";

const removeProducts = (product_ids, callback) => {
  post(
    "/products/products/delete_multiple_products.json",
    {
      product_ids
    },
    "DELETE"
  ).then(callback);
};

const addBranchRestrictions = (product_ids, company_branch_ids, callback) => {
  post("/products/products/add_branch_restrictions.json", {
    product_ids,
    company_branch_ids
  }).then(callback);
};

const removeBranchRestrictions = (product_ids, company_branch_ids, callback) => {
  post("/products/products/remove_branch_restrictions.json", {
    product_ids,
    company_branch_ids
  }).then(callback);
};

// const findProducts = (filter) => {
//     const { setProducts, setMode, company_id } = this.props;
//     const {
//       view,
//       product_name,
//       created_after,
//       client_suite_ids,
//       sample_information_ids,
//       client_specification_ids
//     } = filter;
//     fetchJson("/products/products.json", {
//       company_id,
//       form: {
//         include_schedules: view === "schedules",
//         include_branches: view === "branches",
//         product_name,
//         created_after,
//         created_after: created_after ? created_after.format("YYYY-MM-DD") : null,
//         client_suite_ids,
//         sample_information_ids,
//         client_specification_ids
//       }
//     }).then(json => {
//       setProducts(json.products, view);
//     });
//   };

export { removeProducts, addBranchRestrictions, removeBranchRestrictions };
